import { useState } from "react";
import WebinarTopBar from "./components/WebinarTopBar";
import WebinarNavbar from "./components/WebinarNavbar";
import WebinarHero from "./components/WebinarHero";
import WebinarLearnSection from "./components/WebinarLearnSection";
import WebinarAudienceSection from "./components/WebinarAudienceSection";
import WebinarTrustSection from "./components/WebinarTrustSection";
import WebinarROISection from "./components/WebinarROISection";
import WebinarPresenterSection from "./components/WebinarPresenterSection";
import WebinarFooter from "./components/WebinarFooter";
import FormModal from "../home/components/FormModal";
import WebinarStickyRegister from "./components/WebinarStickyRegister";

// ... existing code ...

export default function WebinarPage() {
  const [marketModalOpen, setMarketModalOpen] = useState(false);

  const scrollToForm = () => {
    const el = document.getElementById("webinar-form");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
  };

  return (
    <div className="min-h-screen bg-white font-sans">
      {/* ... existing metadata tags ... */}
      <title>Free Webinar: Win More Closings with AI Outreach | Imperium</title>
      <meta
        name="description"
        content="Join founder James Schlimmer live on April 15. See how Imperium's AI fires outreach from real listings and helps title teams win more closings. Register free."
      />
      <link rel="canonical" href="https://imperium.chat/webinar" />

      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://imperium.chat/webinar" />
      <meta property="og:title" content="Free Live Webinar: How Title Companies Win More Closings | Imperium" />
      <meta
        property="og:description"
        content="Watch live as Imperium fires AI-powered calls the moment a listing hits the MLS. Founder James Schlimmer walks through every step — free, April 15. Register now to secure your spot."
      />
      <meta
        property="og:image"
        content="https://public.readdy.ai/ai/img_res/26f15a15a9d83089d9704b71142f2de3.jpg"
      />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Free Webinar: AI Outreach That Wins Closings | Imperium" />
      <meta
        name="twitter:description"
        content="Imperium fires AI calls the moment listings go live. See it live — founder James Schlimmer, April 15, free webinar. Register now."
      />
      <meta
        name="twitter:image"
        content="https://readdy.ai/api/search-image?query=sleek%20professional%20webinar%20registration%20landing%20page%20for%20AI%20software%20platform%2C%20dark%20navy%20blue%20background%2C%20bold%20orange%20accent%20color%2C%20clean%20modern%20typography%2C%20glowing%20dashboard%20interface%20mockup%2C%20corporate%20technology%20branding%2C%20high%20contrast%2C%20no%20people%2C%20minimal%20abstract%20design&width=1200&height=630&seq=imperium-webinar-og-2026&orientation=landscape"
      />

      <WebinarTopBar />
      <WebinarNavbar onMarketCTA={() => setMarketModalOpen(true)} />
      <main>
        <WebinarHero />
        <WebinarLearnSection />
        <WebinarAudienceSection />
        <WebinarTrustSection />
        <WebinarROISection onRegister={scrollToForm} />
        <WebinarPresenterSection />
      </main>
      <WebinarFooter />

      {/* Sticky mobile register bar */}
      <WebinarStickyRegister />

      <FormModal
        isOpen={marketModalOpen}
        onClose={() => setMarketModalOpen(false)}
        type="market"
      />
    </div>
  );
}
